


import { Component, Vue } from 'vue-property-decorator';
import ResponsiveImage from '@/components/utils/ResponsiveImage/index.vue';

@Component({
  components: {
    ResponsiveImage
  }
})
export default class MobileOverlay extends Vue {
  private image = {
    MQ1: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ2: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ3: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ4: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ5: require('@/assets/images/mobile_bg_portrait.jpg'),
    MQ6: require('@/assets/images/mobile_bg_portrait.jpg')
  };
}
